var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("特典一覧")])])],1),_c('PrivilegeList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }